module.exports = __webpack_public_path__ + "media/img/ms-icon-150x150-18cd43583358b4bad678ba066763166b.png";